import { MapPin, ArrowRight } from "lucide-react";
import { JobsContent, t } from "@/content/jobs";

import React, { useState, forwardRef } from "react";

const RoleCard = forwardRef(function RoleCard({ job, lang, T, onClick }, ref) {
  const [hover, setHover] = useState(false);
  return (
    <button
      ref={ref}
      type="button"
      onClick={() => onClick(job.slug)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        textAlign: "left", display: "flex", flexDirection: "column",
        padding: "40px 36px 32px", borderRadius: 24,
        backgroundColor: T.bgElev,
        border: `1px solid ${hover ? T.primary : T.border}`,
        transition: "all 250ms cubic-bezier(0.4, 0, 0.2, 1)",
        cursor: "pointer",
        boxShadow: hover ? "0 20px 40px -20px rgba(78,35,207,0.25)" : "none",
        transform: hover ? "translateY(-2px)" : "translateY(0)",
        width: "100%", minHeight: 320
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 28 }}>
        <div style={{
          fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
          fontSize: 56, fontWeight: 200, letterSpacing: "-0.04em",
          color: hover ? T.primary : T.textFaint, lineHeight: 1, transition: "color 200ms"
        }}>
          {job.number}
        </div>
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          padding: "5px 10px", borderRadius: 6, fontSize: 11, fontWeight: 600,
          backgroundColor: T.dangerSoft, color: T.danger,
          fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
          letterSpacing: "0.06em", textTransform: "uppercase"
        }}>
          <span style={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: T.danger }} />
          {t(JobsContent.ui.hiring_now, lang)}
        </div>
      </div>

      <div style={{
        fontFamily: "ui-monospace, Menlo, monospace",
        fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase",
        color: T.amber, marginBottom: 14, fontWeight: 600
      }}>
        {t(job.department, lang)}
      </div>

      <h3 style={{
        fontSize: "clamp(1.5rem, 2.2vw, 1.875rem)",
        fontWeight: 700, lineHeight: 1.08, letterSpacing: "-0.025em",
        color: T.text, whiteSpace: "pre-line", margin: "0 0 20px"
      }}>
        {t(job.title, lang)}
      </h3>

      <p style={{ fontSize: 15, lineHeight: 1.6, color: T.textMute, flexGrow: 1, margin: "0 0 24px" }}>
        {t(job.short_pitch, lang)}
      </p>

      <div style={{
        display: "flex", justifyContent: "space-between", alignItems: "center",
        paddingTop: 20, borderTop: `1px solid ${T.borderSubtle}`
      }}>
        <div style={{ display: "inline-flex", alignItems: "center", fontSize: 12, color: T.textFaint }}>
          <MapPin size={13} strokeWidth={2} style={{ marginRight: 6, flexShrink: 0 }} />
          <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 180 }}>
            {t(job.location, lang)}
          </span>
        </div>
        <span style={{
          display: "inline-flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 600,
          color: T.primary,
          transform: hover ? "translateX(4px)" : "translateX(0)", transition: "transform 200ms"
        }}>
          {t(JobsContent.ui.read_brief, lang)}
          <ArrowRight size={15} strokeWidth={2.5} />
        </span>
      </div>
    </button>
  );
});

export default RoleCard;
